module.exports = __webpack_public_path__ + "static/media/stromtech-3.3d96e70c.jpg";